var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(_setup.KhSelect, {
    attrs: {
      items: _setup.itemList,
      loading: _setup.loading,
      "item-value": "id",
      "item-text": "name",
      clearable: "",
      dense: "",
    },
    on: { input: (newValue) => _setup.emit("input", newValue) },
    model: {
      value: _vm.value,
      callback: function ($$v) {
        _vm.value = $$v
      },
      expression: "value",
    },
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }